import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "brief-info" }
const _hoisted_2 = { class: "joy-panel__header" }
const _hoisted_3 = { class: "brief-info__title" }

import {JoyIconsId} from '@maltjoy/icons';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyTooltipInfo',
  props: {
        title: {type: String, required: true},
        content: String,
        icon: String,
    },
  setup(__props) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("div", _hoisted_3, [
          (__props.icon)
            ? (_openBlock(), _createBlock(_component_VJoyIcon, {
                key: 0,
                name: __props.icon as JoyIconsId
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(props.title), 1)
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})